
window.Vivense = window.Vivense || {};

Vivense.facebookLogin = (function($) {

    function handleFacebookLoginResult(data) {
        if (data.success) {
            Vivense.loginPopup.finishSuccessfulLogin();
        } else {
            Vivense.loginPopup.displayLoginError(data);
        }
    }

    function addPrivacyAgreementIfChecked(params) {
            params.push({
                name: 'accept_privacy_agreement',
                value: 1
            });
    }

    function fbUserConnected() {
        var loginForm = Vivense.loginPopup.getLoginForm();

        var params = loginForm.serializeArray();
        Vivense.loginPopup.addStandardParameters(params);

        for (var i=0; i < params.length; i++) {
            if (params[i].name == 'username' || params[i].name == 'password') {
                params[i].value = 'Facebook';
            }
        }

        addPrivacyAgreementIfChecked(params);

        $.post(loginForm.attr('action'), $.param(params))
            .done(handleFacebookLoginResult)
            .fail(function() {
                Vivense.loginPopup.enableAllButtons();
                Vivense.displayError('Bir hata oluştu, lütfen tekrar deneyin.');
            });
    }

    function fbLoginDialogResult(response) {
        if (response.status === 'connected') {
            fbUserConnected();
        }
        else {
            Vivense.loginPopup.enableAllButtons();
            if (response.status === 'not_authorized') {
                // The person is logged into Facebook, but not your app.
                // TODO: DISPLAY MESSAGE
            } else {
                // The person is not logged into Facebook, so we're not sure if
                // they are logged into this app or not.
            }
        }
    }

    function fbLogin(clickEvent) {
        Vivense.loginPopup.disableAllButtons();
        // add the user_birthday permission later
        FB.login(fbLoginDialogResult, { scope: 'public_profile,email' });
    }

    $(document).ready(function() {
        $('.fb-login-btn').click(fbLogin);
    });

})(jQuery);

window.fbAsyncInit = function() {
    FB.init({
        appId      : '1609628825987991',
        xfbml      : false,
        cookie     : true,
        version    : 'v2.12'
    });
};

(function(d, s, id){
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {return;}
    js = d.createElement(s); js.id = id;
    js.src = "//connect.facebook.net/tr_TR/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));
